import type { ComponentChild, ComponentChildren } from "preact";

export const OPEN_FLYOUT = "OPEN_FLYOUT";
export const CLOSE_FLYOUT = "CLOSE_FLYOUT";
export const OPEN_HELP_OVERLAY = "OPEN_HELP_OVERLAY";
export const CLOSE_HELP_OVERLAY = "CLOSE_HELP_OVERLAY";
export const TOAST = "TOAST";

export type OpenHelpOverlayAction = {
    type: typeof OPEN_HELP_OVERLAY,
    payload: {
        helpId: string;
    }
};

export type ToastAction = {
    type: typeof TOAST,
    payload: {
        message: string;
        type?: "info" | "warning" | "error";
        undo?: () => void;
    }
};

export type OpenFlyoutAction = {
    type: typeof OPEN_FLYOUT,
    payload: {
        ui: ComponentChildren;
    }
};

type SimpleActionType =
    typeof CLOSE_HELP_OVERLAY
    | typeof CLOSE_FLYOUT;

type ComplexActionType =
    typeof OPEN_HELP_OVERLAY
    | typeof TOAST
    | typeof OPEN_FLYOUT;

export type ActionType = SimpleActionType | ComplexActionType;

type ComplexAction =
    OpenHelpOverlayAction
    | ToastAction
    | OpenFlyoutAction;

export type Action = ComplexAction | { type: SimpleActionType }

export interface ActionMap {
    [OPEN_HELP_OVERLAY]: (message: OpenHelpOverlayAction) => void;
    [TOAST]: (message: ToastAction) => void;
    [OPEN_FLYOUT]: (message: OpenFlyoutAction) => void;
}
